module.exports = __webpack_public_path__ + "img/img_title_kuaibaodian_active.ca6d7929.png";